import React from 'react'

import InputField from 'src/components/InputField'
import tipOptions from 'src/utils/tipOptions'

const TippingSelect = ({ i18n, donation }) => {
  const handleChange = e => {
    if (e.target.value)
      donation.dispatch({ type: 'setTipOption', value: e.target.value })
    else
      donation.toggleOtherTip()
  }

  return (
    <InputField
      type="select"
      id="tipOption"
      label={i18n.t('tip_label')}
      labelClass="visually-hidden"
      value={donation.state.otherTip ? '' : donation.state.tipOption}
      onChange={handleChange}
      options={tipOptions({
        options: donation.tippingConfig.options,
        zeroTip: donation.zeroTip,
        currency: donation.currency,
        i18n,
      })}
    />
  )
}

export default TippingSelect
